module.exports = __webpack_public_path__ + "img/rotate-right.e19f52d8.svg";